import { sleep } from "@/lib/utils";

import type { Api, DeliveryConfig, ModerationSettings } from "../types";

// Mutable in-memory delivery pricing — the offline mirror of the gateway's
// `settings` row. Edits from the Delivery Settings page persist for the
// session so the admin UX is fully exercised without a backend.
const config: DeliveryConfig = {
	fees: { standard: 300, express: 700, pickup: 0 },
	freeOver: 15000,
	updatedAt: new Date().toISOString(),
};

// Правила модерации цен — то же зеркало настройки гейтвея.
const moderation: ModerationSettings = { discountWholeProductOnly: false };

export const settings: Api["settings"] = {
	async getDelivery() {
		await sleep(120);
		return { ...config, fees: { ...config.fees } };
	},
	async getModeration() {
		await sleep(100);
		return { ...moderation };
	},
	async updateModeration(patch) {
		await sleep(150);
		if (patch.discountWholeProductOnly !== undefined)
			moderation.discountWholeProductOnly = patch.discountWholeProductOnly;
		return { ...moderation };
	},
	async updateDelivery(patch) {
		await sleep(200);
		if (patch.fees) config.fees = { ...config.fees, ...patch.fees };
		if (patch.freeOver !== undefined) config.freeOver = patch.freeOver;
		config.updatedAt = new Date().toISOString();
		return { ...config, fees: { ...config.fees } };
	},
};
